






















































// Vue
import { defineComponent, PropType, computed } from '@vue/composition-api'

// components
import { Form, Input, Radio, Button, Icon } from '@/components/general'

// models
import { AdvanceTypeForm } from '@/models/config'

// services
import { AdvanceTypesService } from '@/services/config'

// Vuelidate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// utils
import { alerts, loading } from '@/utils'

// constants
import { optionsStatus } from '@/constants'

export default defineComponent({
  name: 'AdvanceTypeFormCreateEdit',
  components: {
    Form,
    Input,
    Radio,
    Button,
    Icon
  },
  props: {
    item: {
      type: Object as PropType<AdvanceTypeForm>,
      required: true
    },
    idEdit: {
      type: Number as PropType<number>,
      default: null
    },
    action: {
      type: String as PropType<'save'|'update'>,
      required: true
    }
  },
  setup (props, { emit }) {
    const rules = computed(() => ({
      item: {
        name: { required },
        apply_afp: { required },
        is_active: { required }
      }
    }))
    const optionsApply = [
      {
          text: 'SI',
          value: true
      },
      {
          text: 'NO',
          value: false
      }
    ]
    const $v = useVuelidate(rules, { item: props.item })
    const save = async () => {
      if (!$v.value.item.$invalid) {
        try {
          loading('show')
          if (props.action === 'save') {
            await AdvanceTypesService.create(props.item)
          } else {
            await AdvanceTypesService.update(props.idEdit, props.item)
          }
          loading('hide')
          alerts.success()
          emit('save-success')
        } catch (e) {
          alerts.error('ERROR.! No se pudo completar la operación')
          loading('hide')
        }
      } else {
        alerts.error('Debe completar todos los campos')
      }
    }
    return {
      save,
      optionsStatus,
      $v,
      optionsApply
    }
  }
})
